<template>
    <div ref="root">
        <div
            class="sectors__container module__container"
            v-bind:class="{ container__fluid: [1, 2, 3].includes(module.layout.type) }"
        >
            <div class="sectors__inner module__inner">
                <div class="sectors__inner--main module__inner--main">
                    <div
                        class="sectors__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle || module.data.text"
                    >
                        <div class="sectors__inner-col module__inner-col">
                            <div
                                class="sectors__header module__header"
                                v-bind:class="'bg-color module--color-' + module.appearance.color"
                            >
                                <app-modulebackground
                                    :module-id="module.id"
                                    custom-class="sectors__background module__background"
                                ></app-modulebackground>
                                <h2
                                    class="sectors__title module__title font-h2 color-h2"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="sectors__subtitle module__subtitle font-h3 color-h3"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                                <div
                                    class="sectors__text module__text font-p color-p module__cms"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.text"
                                    v-html="module.data.text"
                                ></div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="sectors__inner-row module__inner-row"
                        v-if="items && Array.isArray(items) && items.length > 0"
                    >
                        <div class="sectors__inner-col module__inner-col">
                            <div class="sectors__list module__list">
                                <div
                                    v-for="(items__value, items__key) in items"
                                    v-bind:key="items__value.id"
                                    :data-id="items__value.id"
                                    :data-preset-id="items__value.preset_id"
                                    class="sectors__sector-single module__list-item bg-color"
                                    :class="[
                                        {
                                            'module--color-1':
                                                (items__key % 2 !== 0 &&
                                                    [1].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [1, 3].includes(parseInt(getActiveTheme)) &&
                                                    [2, 3, 4, 5, 6, 7].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-2':
                                                (items__key % 2 !== 0 &&
                                                    [2].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [1, 3].includes(parseInt(getActiveTheme)) &&
                                                    [1].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-3':
                                                (items__key % 2 !== 0 &&
                                                    [3].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [4].includes(parseInt(getActiveTheme)) &&
                                                    [1, 2, 4, 5, 6, 7].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-4':
                                                (items__key % 2 !== 0 &&
                                                    [4].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [4].includes(parseInt(getActiveTheme)) &&
                                                    [3].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-5':
                                                items__key % 2 !== 0 &&
                                                [5].includes(parseInt(module.appearance.color)),
                                            'module--color-6':
                                                (items__key % 2 !== 0 &&
                                                    [6].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [2].includes(parseInt(getActiveTheme)) &&
                                                    [1, 2, 3, 4, 5, 7].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-7':
                                                (items__key % 2 !== 0 &&
                                                    [7].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [2].includes(parseInt(getActiveTheme)) &&
                                                    [6].includes(parseInt(module.appearance.color)))
                                        }
                                    ]"
                                >
                                    <app-configbar
                                        v-if="editorMode"
                                        :show-data="true"
                                        :show-layout="false"
                                        :show-appearance="false"
                                        v-on:open="
                                            directEditListeditor({
                                                dataSource: 'deha.user.misc.sectors',
                                                listSubpage: 'Sectors',
                                                module_id: module.id,
                                                listitem_id: items__value.id
                                            })
                                        "
                                        inner
                                    ></app-configbar>

                                    <div
                                        class="sectors__sector-single-details flex--wrap"
                                        v-bind:class="{
                                            container__fluid: [2].includes(module.layout.type),
                                            container__boxed: [1].includes(module.layout.type)
                                        }"
                                    >
                                        <div
                                            class="sectors__sector-single--left"
                                            v-bind:class="{
                                                'bg-color': [2].includes(module.layout.type),
                                                'col__width--half': [1].includes(
                                                    module.layout.type
                                                ),
                                                'calc-padding--left': [3].includes(
                                                    module.layout.type
                                                )
                                            }"
                                        >
                                            <div
                                                class="sectors__inner-row module__inner-row"
                                                v-if="
                                                    items__value.data &&
                                                        (items__value.data.icon ||
                                                            items__value.data.name ||
                                                            items__value.data.title ||
                                                            items__value.data.subtitle)
                                                "
                                            >
                                                <div class="sectors__inner-col module__inner-col">
                                                    <div
                                                        class="sectors__sector-single--header flex--nowrap"
                                                    >
                                                        <div
                                                            class="sectors__sector-single--header-left"
                                                        >
                                                            <app-moduleicon
                                                                v-if="
                                                                    [1, 3].includes(
                                                                        module.layout.type
                                                                    )
                                                                "
                                                                :data="
                                                                    items__value.data.icon || {
                                                                        id: getRandomButDeterminedImageInNamespaceBasedOnUser(
                                                                            'icons/sectors/default',
                                                                            items__value.id
                                                                        )
                                                                    }
                                                                "
                                                                :custom-class="
                                                                    'sectors__sector-single--icon module__icon'
                                                                "
                                                            ></app-moduleicon>
                                                        </div>
                                                        <div
                                                            class="sectors__sector-single--header-right flex--wrap"
                                                        >
                                                            <h3
                                                                class="sectors__sector-single--title module__title font-h2 color-h2"
                                                                v-if="items__value.data.title"
                                                                v-html="items__value.data.title"
                                                            ></h3>
                                                            <h3
                                                                class="sectors__sector-single--title module__title font-h2 color-h2"
                                                                v-else-if="items__value.data.name"
                                                                v-html="items__value.data.name"
                                                            ></h3>
                                                            <h4
                                                                v-if="items__value.data.subtitle"
                                                                class="sectors__sector-single--subtitle module__subtitle font-h3 color-h3"
                                                                v-html="items__value.data.subtitle"
                                                            ></h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="sectors__inner-row module__inner-row"
                                                v-if="items__value.data && items__value.data.text"
                                            >
                                                <div class="sectors__inner-col module__inner-col">
                                                    <div
                                                        class="sectors__sector-single--description module__text font-p color-p module__cms"
                                                        v-html="items__value.data.text"
                                                    ></div>
                                                </div>
                                            </div>
                                            <div
                                                class="sectors__inner-row module__inner-row"
                                                v-if="
                                                    items__value.data &&
                                                        ((items__value.data.link &&
                                                            items__value.data.link.active) ||
                                                            (items__value.data.link2 &&
                                                                items__value.data.link2.active) ||
                                                            (items__value.data.link3 &&
                                                                items__value.data.link3.active))
                                                "
                                            >
                                                <div class="sectors__inner-col module__inner-col">
                                                    <div class="sectors__sector-single--btn">
                                                        <div class="sectors__cta module__cta">
                                                            <app-modulebutton
                                                                :data="items__value.data.link"
                                                                :custom-class="
                                                                    'sectors__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                                "
                                                            ></app-modulebutton>
                                                            <app-modulebutton
                                                                :data="items__value.data.link2"
                                                                :custom-class="
                                                                    'sectors__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                                "
                                                            ></app-modulebutton>
                                                            <app-modulebutton
                                                                :data="items__value.data.link3"
                                                                :custom-class="
                                                                    'sectors__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                                "
                                                            ></app-modulebutton>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="sectors__sector-single--right module__inner--image"
                                            v-bind:class="{
                                                'col__width--half': [1].includes(module.layout.type)
                                            }"
                                            v-if="
                                                [1, 2, 3].includes(module.layout.type) &&
                                                    items__value.data &&
                                                    items__value.data.image &&
                                                    items__value.data.image.id
                                            "
                                        >
                                            <app-moduleimage
                                                v-if="[1, 2, 3].includes(module.layout.type)"
                                                :data="items__value.data.image"
                                                :tag="'div'"
                                                :custom-class="'sectors__sector-single--image'"
                                            ></app-moduleimage>
                                        </div>
                                        <div
                                            class="sectors__sector-single--right module__inner--image"
                                            v-bind:class="{
                                                'col__width--half': [1].includes(module.layout.type)
                                            }"
                                            v-else
                                        >
                                            <div
                                                class="image-container image-container--div sectors__sector-single--image"
                                                v-bind:style="
                                                    'background-image: url(\'' +
                                                        generateMediaUrl({
                                                            path:
                                                                'media/images/sectors/default/' +
                                                                (module.appearance.color == 1
                                                                    ? '1'
                                                                    : '2') +
                                                                '.jpg'
                                                        }) +
                                                        '\')'
                                                "
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="sectors__inner-row module__inner-row"
                        v-if="
                            [5, 6].includes(module.layout.type) &&
                                module.data.link &&
                                module.data.link.active
                        "
                    >
                        <div class="sectors__inner-col module__inner-col">
                            <div class="sectors__cta module__cta">
                                <app-modulebutton
                                    v-if="[5, 6].includes(module.layout.type)"
                                    :data="module.data.link"
                                    :custom-class="
                                        'sectors__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleIcon from '@/components/assorted/ModuleIcon';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import Configbar from '@/components/assorted/Configbar.vue';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleicon': ModuleIcon,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground,
        'app-configbar': Configbar
    },
    methods: {
        ...mapActions(['routeAddQuery', 'directEditListeditor'])
    },
    computed: {
        ...mapGetters([
            'getListItems',
            'editorMode',
            'getActiveTheme',
            'getRandomButDeterminedImageInNamespaceBasedOnUser',
            'generateMediaUrl'
        ]),
        items() {
            return this.getListItems('deha.user.misc.sectors');
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
